/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Provider, useDispatch, useSelector } from "react-redux";
import "./houseCardGalleryBlock.css";
import "./responsive.css";
import axios from "axios";
import HouseCardGallery from "../../components/HouseCardGallery/HouseCardGallery";
import {
  addListingData,
  addListingImgsData,
  setListingData,
} from "../../store/actions/setListingDataActions";
import { ReactDOM, hydrateRoot } from "react-dom/client";
import ReactDOMServer from "react-dom/server";

import ListingDetailBlock from "../../components/ListingDetailBlock/ListingDetailBlock";

const HouseCardGalleryBlock = ({ container }) => {
  const BuyerAgencyCompensationTooltip = `Buyer Broker Compensation Offered: This indicates the commission percentage or fee that the seller and the listing agent have agreed to pay to the buyer's agent. This compensation is intended to cover the services provided by the buyer's agent in representing and assisting the buyer throughout the real estate transaction.`;
  const dispatch = useDispatch();
  const addListingDataState = useSelector((state) => state.listingData);
  const [data, setData] = useState(null);
  const [dataError, setDataError] = useState(null);
  const [heardData, setHeardData] = useState([{ id: null, value: 4 }]);
  const [images, setImages] = useState(null);
  const [isLogin, setIsLogin] = useState(null);
  const [listingDocuments, setListingDocuments] = useState(null);
  const dataImagesListing = container?.getAttribute("data-image-listing");

  let picturesFeature = container.getAttribute("pictures-feature");
  if (picturesFeature !== "true") picturesFeature = "false";
  const [isPicturesFeature, setIsPicturesFeature] = useState(picturesFeature);

  const mutationCallback = (mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type !== "attributes" ||
        mutation.attributeName !== "pictures-feature"
      ) {
        return;
      }
      setIsPicturesFeature(
        // prev_value: mutation.oldValue,
        mutation.target.getAttribute("pictures-feature")
      );
    }
  };

  const observer = new MutationObserver(mutationCallback);
  observer.observe(container, { attributes: true });

  document.addEventListener("RTUnlockPremiumFeatures", function (event) {
    setIsPicturesFeature("true");
  });

  const defaultMediaUrl =
    "https://realtytexas.com/assets/images/placeholder-image.jpg";

  const defaultImgData = {
    MediaURL: defaultMediaUrl,
    order: 1,
    ShortDescription: null,
    LongDescription: null,
  };

  useEffect(() => {
    setImages(null);
    if (dataImagesListing) {
      axios
        //this URL should be changed!!!
        .get(
          //   `https://cd4.realtytexas.com:8023/api/v1/listings/${dataImagesListing}/info?$expand=images,openhouse`
          `https://api.realtytexas.net/v2/listings/${dataImagesListing}/info`
        )
        .then(function (response) {
          //   setData(response.data.data);
          if (response?.data?.data[0]?.OpenHouse.length > 0) {
            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);
            response.data.data[0].OpenHouse =
              response.data.data[0].OpenHouse.filter((openHouse) => {
                const openHouseDate = new Date(openHouse.OpenHouseDate);
                const utcOpenHouseDate = new Date(
                  openHouseDate.getTime() +
                    openHouseDate.getTimezoneOffset() * 60000
                );
                return utcOpenHouseDate >= currentDate;
              });
          }

          setData(response.data.data[0]);
          const tempImages = response.data.data[0]?.Media?.filter((img,index) => {
            if(response.data.data[0].LimitImages && response.data.data[0].MlsStatus==="Closed"){
              if(index===0){
                return img;
              }
            }
            else{
              return img;
            }
          })?.map((url) => {
            return {
              MediaURL:
                "https://propertyimages.realtytexas.com" + url?.MediaURL,
              order: url?.Order,
              ImageOf: url?.ImageOf,
              LongDescription: url?.LongDescription,
              ShortDescription: url?.ShortDescription,
            };
          });
          //   setImages([...response.data.data.images]);
          setImages([...tempImages]);

          if (
            !response.data.data[0]?.Media ||
            response.data.data[0]?.Media?.length === 0
          ) {
            setImages([defaultImgData]);
          }

          // const clone = (({ images, OpenHouse, ...o }) => o)(
          //   Object.values(response.data.data)?.[0]
          // );
          // const clone = {...response.data.data?.[0], Media : tempImages}
          // dispatch(addListingData(clone));
          //   if (response.data.data.images.length > 0)
          //   dispatch(addListingImgsData([...response.data.data.images]))
        })
        .catch(function (error) {
          console.log(error, "error");
        });
    }
  }, []);

  useEffect(() => {
    if(images){
      const clone = {...data, Media : images}
          dispatch(addListingData(clone));
    }
  }, [images, data])

  //   useEffect(() => {
  //     console.log(addListingDataState,'addListingDataState')
  //   }, [addListingDataState]);

  // function userLoginHandler() {
  //   const myRTP = window.localStorage.getItem("MyRTP");
  //   if (myRTP !== null) {
  //     setIsLogin(true);
  //   } else setIsLogin(false);
  // }

  const urlParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    if (urlParams.has("IdentityAlias")) {
      setIsLogin(true);
      window.localStorage.setItem(
        "MyRTP",
        JSON.stringify({ SubjectID: urlParams.get("IdentityAlias") })
      );
    }
  }, []);

  // document.addEventListener("RTUserLoginEvent", userLoginHandler);

  // useEffect(() => {
  //   userLoginHandler();
  // }, []);

  const getUserHeardList = () => {
    const myRTP = JSON.parse(localStorage?.getItem("MyRTP"));
    const listingInteractions = JSON?.parse(
      localStorage?.getItem("listingInteractions")
    );

    if (myRTP?.SubjectID) {
      if (listingInteractions?.listings) {
        setHeardData([
          ...listingInteractions?.listings.map((item) => {
            return { id: +item.id, value: item.value };
          }),
        ]);
      } else {
        setHeardData([{ id: null, value: 4 }]);
      }
      // axios
      //   .get(
      //     `https://web.realtytexas.io/api/v1/clients/identity/${myRTP.SubjectID}/listings/interactions`
      //   )
      //   .then(function (response) {
      //     setHeardData([
      //       ...response?.data?.data.map((item) => {
      //         return { id: +item.id, value: item.value };
      //       }),
      //     ]);
      //   })
      //   .catch(function (error) {
      //     console.log(error);
      //   });
    }
  };

  useEffect(() => {
    const myRTP = JSON?.parse(localStorage?.getItem("MyRTP"));
    if (myRTP?.SubjectID) {
      getUserHeardList();
    }
  }, []);

  const handleRTLoginEvent = () => {
    setIsLogin(true);
    getUserHeardList();
  };

  useEffect(() => {
    document.addEventListener("RTLoginEvent", handleRTLoginEvent);
    return () => {
      document.removeEventListener("RTLoginEvent", handleRTLoginEvent);
    };
  }, []);

  useEffect(() => {
    if (data && data?.rtlist == true) {
      if (
        data?.MlsStatus === "Active" ||
        data?.MlsStatus === "ActiveUnderContract" ||
        data?.MlsStatus === "ComingSoon" ||
        data?.MlsStatus === "Contingent" ||
        data?.MlsStatus === "Incomplete" ||
        data?.MlsStatus === "Pending"
      ) {
        const tableDetails = document?.getElementById(
          "table-details-block-wrapper"
        );
        axios
          .get(
            `https://api.realtytexas.net/v2/listings/${data?.ListingKeyNumeric}/docs`
          )
          .then((res) => {
            if (res?.data?.success) {
              const items = res?.data?.data.map((item) => {
                item.value = item.public_file_title;
                item.link = true;
                item.url = `${item.FileHost}${item.public_url}`;
                return item;
              });
              if (tableDetails) {
                const htmlString = ReactDOMServer.renderToString(
                  <ListingDetailBlock
                    title={"PROPERTY DISCLOSURES & ADDENDA"}
                    items={items}
                  />
                );
                tableDetails.innerHTML += htmlString;
              }
            }

            if (data?.BuyerAgencyCompensation) {
              const htmlString2 = ReactDOMServer.renderToString(
                <ListingDetailBlock
                  title={"BUYER BROKER COMPENSATION OFFERED"}
                  tooltip={BuyerAgencyCompensationTooltip}
                  items={[
                    {
                      title: "Compensation",
                      value: data.BuyerAgencyCompensation,
                    },
                  ]}
                />
              );
              if (tableDetails) {
                tableDetails.innerHTML += htmlString2;
              }
              let infoTooltip = tableDetails?.querySelector(
                ".title-info-tooltip"
              );
              if (infoTooltip) {
                infoTooltip.innerHTML += `
                            <div class="tooltip-wrapper"  style="display:none;">
                                <div class="house-card-BA-component-tooltip" style="width: 315px;height: 136px;font-size: 14px;text-transform: none;">
                                    <p>${BuyerAgencyCompensationTooltip}</p>
                                </div>
                                <div class="house-card-BA-component-tooltip-triangle" style="top: 32px;" />
                            </div>

                        `;
                let tooltipDiv = infoTooltip.querySelector(".tooltip-wrapper");
                infoTooltip.addEventListener("click", function (e) {
                  if (tooltipDiv.style.display == "none") {
                    tooltipDiv.style.display = "block";
                  } else {
                    tooltipDiv.style.display = "none";
                  }
                });
              }
            }
          });
      }
    }
  }, [data]);

  return (
    <div style={{ height: "100%", width: "100%" }}>
      {data && (
        <HouseCardGallery
          item={data}
          heardData={heardData}
          setHeardData={setHeardData}
          listingsData={data}
          images={images}
          isLogin={isLogin}
          container={container}
          isPicturesFeature={isPicturesFeature}
        />
      )}
    </div>
  );
};

export default HouseCardGalleryBlock;
